import { H2Text } from 'components/Typography';
import {
  ConfirmationBackgroundContainer,
  DonateAgainCardsRow,
  DonateAgainContainer,
  ExploreOtherIssuesButton,
} from './styled';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { getRecommendationsState } from 'selectors/recommendations';
import { getSetsState } from 'selectors/sets';
import { FC, useEffect } from 'react';
import { getUserState } from 'selectors/user';
import { getRecommendations } from 'store/recommendations/actions';
import { getSets } from 'store/sets/actions';
import { getPathWithRef, getUrlParams /*, isKeyInObject*/ } from 'helpers/utils';
// import { getIsCheckoutMonthly } from './Form/utils';
import { IPage } from 'store/donatePage/types';
// import { tabIssues as monthlyIssues } from 'screens/Monthly/constants';
import { DEDonateAgainCard } from './DEDonateAgainCard';
import theme from 'config/theme';
import Loader from 'components/Loader';
import { SET_QUERY_STRINGS } from 'constants/dbRecords';

const CARD_COUNT = 3;

interface Props {
  donationAmount: number;
  handleNewDonationSelections: () => void;
  id: string;
}

export const DEDonateAgain: FC<Props> = ({ donationAmount, handleNewDonationSelections, id }) => {
  const { urlPartner } = getUrlParams();
  const dispatch = useAppDispatch();
  const { recommendations, sets, userState } = useAppSelector(state => ({
    recommendations: getRecommendationsState(state),
    sets: getSetsState(state),
    userState: getUserState(state),
  }));

  useEffect(() => {
    if (!recommendations.data && userState.data) {
      dispatch(getRecommendations());
    }
    if (sets?.data?.querystring !== SET_QUERY_STRINGS.POST_ELECTION_2024) {
      dispatch(getSets(SET_QUERY_STRINGS.POST_ELECTION_2024));
    }
  }, [recommendations.data, sets.data]);

  const getRecommendedIssues = () => {
    const recommendedQueryStrs = ['mx'];
    const recommendedIssues: IPage[] = [];
    const filteredSetPages = sets.data.pages
      .map(page => ({
        ...page,
        raised:
          sets.data.set_pages.find(set => set.page_id === page.id)?.page_fundraising_raised || '',
      }))
      .filter(page => page.query_str !== urlPartner && `monthly-${page.query_str}` !== urlPartner);
    // if (getIsCheckoutMonthly() && urlPartner !== 'monthly-infra') {
    //   return filteredSetPages
    //     .filter(page => isKeyInObject(page.query_str, monthlyIssues))
    //     .slice(0, CARD_COUNT)
    //     .map(page => ({ ...page, query_str: `monthly-${page.query_str}` }));
    // }
    // if (!userState.data || !recommendations.data) {
    //   return filteredSetPages.slice(0, CARD_COUNT);
    // }
    for (let i = 0; i < filteredSetPages.length && recommendedIssues.length < CARD_COUNT; i++) {
      const pageIsRecommended = !!recommendedQueryStrs.find(
        recQueryStr => filteredSetPages[i].query_str === recQueryStr
      );
      // const needsRemainingPages =
      //   filteredSetPages.length - i === CARD_COUNT - recommendedIssues.length;
      if (pageIsRecommended /* || needsRemainingPages */) {
        recommendedIssues.push(filteredSetPages[i]);
      }
    }
    return recommendedIssues;
  };

  return (
    <ConfirmationBackgroundContainer $backgroundColor={theme.shadows.oathBlue(0.1)}>
      <DonateAgainContainer id={id}>
        <H2Text>Donate with One Click</H2Text>
        <DonateAgainCardsRow $justifyContent="center">
          {!sets.data || (userState.data && !recommendations.data) ? (
            <div className="loader-center">
              <Loader width={60} height={60} />
            </div>
          ) : (
            getRecommendedIssues().map(issue => (
              <DEDonateAgainCard
                key={issue.id}
                donationAmount={donationAmount}
                handleNewDonationSelections={handleNewDonationSelections}
                issue={issue}
                userId={userState?.data?.id}
              />
            ))
          )}
        </DonateAgainCardsRow>
        <ExploreOtherIssuesButton
          $hasBorder={true}
          $secondary={true}
          to={getPathWithRef(`/set?p=${SET_QUERY_STRINGS.POST_ELECTION_2024}`)}
        >
          Explore Other Issues
        </ExploreOtherIssuesButton>
      </DonateAgainContainer>
    </ConfirmationBackgroundContainer>
  );
};
